<div class="ion-padding">
  <ion-card>
    <ion-card-header>
      <ion-card-title>Licenc</ion-card-title>
      <ion-card-subtitle>
        Az intézmény licencének aktiválása és állapota. Egy intézmény egyszer aktivál – a licenc határozza meg a
        használható modulokat és a korlátokat (hány cég, hány felhasználó). Az al-felhasználók ezen licenc alatt vannak.
      </ion-card-subtitle>
    </ion-card-header>

    <ion-card-content>
      <ion-progress-bar type="indeterminate" *ngIf="loading"></ion-progress-bar>

      <ion-item lines="none">
        <ion-label>
          Állapot:
          <ion-badge [color]="statuszSzin">{{ statuszSzoveg }}</ion-badge>
        </ion-label>
      </ion-item>

      <!-- Aktív licenc részletei -->
      <div *ngIf="licenc">
        <ion-item>
          <ion-label class="ion-text-wrap">
            Licenc: <b>{{ licenc.nev }}</b> <span style="color:#888">({{ licenc.id }}, {{ licenc.tipus }})</span>
          </ion-label>
        </ion-item>
        <ion-item>
          <ion-label class="ion-text-wrap">
            Modulok:
            <span *ngIf="!modulok.length" style="color:#888">összes (nincs korlátozva)</span>
            <ion-badge color="primary" style="margin:2px" *ngFor="let m of modulok">{{ m }}</ion-badge>
          </ion-label>
        </ion-item>
        <ion-item>
          <ion-label class="ion-text-wrap">
            Korlátok: cégek: <b>{{ korlatSzoveg('max_ceg') }}</b> · felhasználók: <b>{{ korlatSzoveg('max_felhasznalo') }}</b>
          </ion-label>
        </ion-item>
        <ion-item>
          <ion-label class="ion-text-wrap">
            Érvényesség: {{ licenc.ervenyes_ig || 'nincs lejárat' }}
          </ion-label>
        </ion-item>
      </div>

      <!-- Offline / szerver-kontakt info -->
      <ion-item lines="none" *ngIf="allapot?.aktiv">
        <ion-note color="medium" class="ion-text-wrap" style="font-size:12px">
          Utolsó szerver-kapcsolat: {{ allapot?.utolso_szerver_kontakt || 'még nem volt' }}.
          Offline türelmi idő: {{ allapot?.turelmi_nap_osszesen }} nap<span *ngIf="allapot?.turelmi_nap_hatra != null">,
          hátralévő: {{ allapot?.turelmi_nap_hatra }} nap</span>.
        </ion-note>
      </ion-item>

      <!-- Aktiválás -->
      <ion-item>
        <ion-label position="stacked">Licenc-kulcs</ion-label>
        <ion-input [(ngModel)]="kulcs" placeholder="Illeszd be a licencszervertől kapott kulcsot"></ion-input>
      </ion-item>

      <div style="display:flex; gap:8px; margin-top:16px; flex-wrap:wrap">
        <ion-button color="success" (click)="aktival()" [disabled]="mentes || loading">
          <ion-icon slot="start" name="key-outline"></ion-icon>
          Aktiválás
        </ion-button>
        <ion-button fill="clear" color="medium" (click)="betolt()" [disabled]="loading">
          Újratöltés
        </ion-button>
      </div>

      <ion-note color="medium" style="display:block; margin-top:12px; font-size:12px">
        A kulcsot az üzemeltetőtől kapod. Beállítás után a rendszer óránként automatikusan frissíti a licencet a
        licencszerverről; ha a szerver átmenetileg nem elérhető, a program a türelmi időn belül tovább működik.
      </ion-note>
    </ion-card-content>
  </ion-card>
</div>
